/** @format */

export const selectedClient = {
  _id: null,
  clientName: '',
  email: '',
  badPayer: '',
  sale: '',
  clientType: '',
};

export const newClient = {
  data: {
    avatarLink: '',
    name: '',
    surname: '',
    fiscalCode: '',
    vatNumber: '',
    email: '',
    mobPhone: '',
    landPhone: '',
    badPayer: false,
    lastPurchase: '',
    requestsNum: 0,
    salesNum: 0,
    salesValue: 0,
    notes: '',
    status: 'attivo',
    timestamp: '',
    type: '',
  },
  requests: {},
  addresses: {},
  purchases: {},
};

export const newClientAddress = {
  data: {
    main: false,
    address: '',
    address2: '',
    zip: '',
    city: '',
    state: '',
    country: '',
    notes: '',
  },
};
